import React, { Component, createRef } from 'react'
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import SwalServices from '../../services/swalServices/SwalServices';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong, faCircleNotch, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown';
import { isValidForm } from '../../utils/validation/CommonValidator';
import JoditEditor from 'jodit-react';
import { checkParameters } from '../../utils/Encryption';
import ValidationText from '../../utils/validation/ValidationText';
import { Navigate } from 'react-router-dom';
import { APIURL, UploadImage } from '../../services/axiosServices/ApiEndPoints';
import { getAuthProps } from '../../utils/AuthenticationLibrary';

let loginUser = getAuthProps();

export default class JobDetails extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.editorRef = createRef();
        this.state = {
            isLoading: false,
            jobId: null,
            locationList: [],
            jobTypeOptions: [
                { label: "Full time", value: 1 },
                { label: "Part time", value: 2 },
                { label: "Bank/Casual", value: 3 },
            ],
            jobForm: {
                jobname: "",
                locationid: [],
                jobtype: [],
                jobcontent: "",
            },
            jobOptions: [],
            roleOptions: ['Superadmin', 'Admin', 'House User'],
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                jobname: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "job name"),
                    },
                ],
                locationid: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "location"),
                    },
                ],
                jobtype: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "job type"),
                    },
                ],
                // jobcontent: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace("{0}", "job description"),
                //     },
                // ],
            },
        };
        this.editorConfig = {
            height: 600,
            placeholder: 'Enter blog content here...',
            readonly: false,
            toolbarSticky: false,
            buttons: [
                'source', '|',
                'bold', 'italic', 'underline', 'strikethrough', '|',
                'superscript', 'subscript', '|',
                'ul', 'ol', '|',
                'indent', 'outdent', '|',
                'align', 'font', 'fontsize', '|',
                'brush', 'paragraph', '|',
                'classSpan', 'spellcheck', '|',
                'link', 'image', 'video', '|',
                'table', 'hr', '|',
                'copyformat', 'cut', 'copy', 'paste', '|',
                'undo', 'redo', '|',
                'selectall', 'removeformat', '|',
                'fullsize', 'preview', 'print'
            ],
            uploader: {
                insertImageAsBase64URI: true,
                imagesExtensions: ['jpg', 'png', 'jpeg'],
                url: APIURL + UploadImage,
                format: 'json',
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${loginUser.token}`,
                },
                isSuccess: (resp) => resp && resp.success === 1,
                getMessage: (resp) => resp.msg || 'Upload failed',
                process: (resp) => {
                    return resp.files[0].url;
                }
            },
            uploaderInsertImageAsBase64URI: false,
            dragAndDrop: true,
            allowResizeX: true,
            allowResizeY: true
        };
    }

    componentDidMount() {
        this.getLocationList()
    }

    getLocationList = () => {
        let request = [0, -1, '', '', ''];
        this.adminServices.getLocationList(request).then((response) => {
            if (response && response.data && response !== null) {
                let res = response.data;
                let dropdownItems = res.map((item) => ({
                    label: item.locationname,
                    value: item.locationid,
                }));
                this.setState({ locationList: dropdownItems }, () => {
                    this.getJobIdFromParams()
                });
            } else {
                this.getJobIdFromParams()
            }
        });
    }

    getJobIdFromParams = () => {
        let params = new URLSearchParams(window.location.search);
        let jobid = Number(params.get(""))
        if (jobid) {
            if (jobid != null && jobid > 0) {
                this.setState({ jobId: jobid }, () => {
                    this.getJobData(this.state.jobId)
                });
            }
        }
    }

    getJobData = (id) => {
        this.adminServices.getJobData(id).then((response) => {
            if (response.success === 1 && response.data !== null) {
                let res = response.data[0];

                const selectedLocations = res.locationid.map(id =>
                    this.state.locationList.find(option => option.value === id)
                );

                const selectedJobTypes = res.jobtype.map(id =>
                    this.state.jobTypeOptions.find(option => option.value === id)
                );

                let details = this.state.jobForm
                details.jobname = res.jobname
                details.jobcontent = res.jobcontent
                details.locationid = selectedLocations
                details.jobtype = selectedJobTypes
                this.setState({ jobForm: details });
            } else {
                this.swalServices.Error(response.msg);
            }
        });
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.jobForm,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.jobForm;
        details[name] = value;
        this.setState({ jobForm: details });
    };

    handleSelectChange = (selectedOptions, fieldName) => {
        let formDetails = this.state.jobForm
        formDetails[fieldName] = selectedOptions
        this.setState({ jobForm: formDetails });
    };

    createJob = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            let details = this.state.jobForm;
            let request = {}
            request.jobName = details.jobname;
            request.locationId = details.locationid.map(option => option.value);
            request.jobType = details.jobtype.map(option => option.value);
            request.jobContent = details.jobcontent;
            this.setState({ isLoading: true })
            this.adminServices.createJob(request).then((response) => {
                if (response.success === 1) {
                    this.setState({ route: "/jobs" })
                    this.swalServices.Success(response.msg)
                } else {
                    this.swalServices.Error(response.msg)
                }
                this.setState({ isLoading: false });
            });
        }
    }

    updateJob = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            let details = this.state.jobForm;
            let request = {}
            request.jobName = details.jobname;
            request.locationId = details.locationid.map(option => option.value);
            request.jobType = details.jobtype.map(option => option.value);
            request.jobContent = details.jobcontent;
            this.setState({ isLoading: true })
            this.adminServices.updateJob(request, this.state.jobId).then((response) => {
                if (response.success === 1) {
                    this.setState({ route: "/jobs" })
                    this.swalServices.Success(response.msg)
                } else {
                    this.swalServices.Error(response.msg)
                }
                this.setState({ isLoading: false });
            });
        }
    }

    handleJobDescriptionChange = (newContent) => {
        this.setState(prevState => ({
            jobForm: {
                ...prevState.jobForm,
                jobcontent: newContent
            }
        }));
    };

    handleDelete = () => {
        this.swalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete ?`
        ).then((response) => {
            if (response === true) {
                this.adminServices.deleteJob(this.state.jobId).then((response) => {
                    if (response.success === 1) {
                        this.swalServices.Success(response.msg);
                        setTimeout(() => {
                            this.setState({ route: "/jobs" })
                        }, 1000);
                    } else {
                        this.swalServices.Error(response.msg)
                    }
                    this.setState({ isLoading: false });
                });
            }
        });
    };

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='job-details'>
                <div className='job-details-inner p-[30px] overflow-y-auto' style={{ height: "calc(100vh - 168.8px)" }}>
                    <div className='title flex items-center justify-between mb-[10px]'>
                        <h1 className='text-[22px] m-0 font-semibold text-[#004AAD]' style={{ lineHeight: "30px" }}>
                            {this.state.jobId > 0 ? 'Edit job' : 'Create job'}
                        </h1>
                        {/* <button className='flex items-center gap-[5px] py-[5px] px-[10px] text-[14px] font-medium rounded-[5px]'><FontAwesomeIcon className='w-5 h-5' icon={faUserPlus} />Add user</button> */}
                    </div>
                    <div className='job-data grid gap-[30px]'>
                        <div className='job-info p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                            <h2 className='text-[16px] font-semibold mt-0'>Job details</h2>
                            <div className='job-info-inner grid grid-cols-2 gap-5'>
                                <div className='input-grp !mb-0 col-span-2'>
                                    <label>Job title:</label>
                                    <input
                                        type='text'
                                        placeholder='Enter job title'
                                        id='jobname'
                                        name='jobname'
                                        className={`${this.state.validState?.error?.jobname ? "error" : ""}`}
                                        value={this.state.jobForm.jobname}
                                        onChange={(event) => this.handleChange(event, "jobname")}
                                    />
                                    <ValidationText error={this.state.validState.error.jobname} />
                                </div>
                                <div className='input-grp !mb-0'>
                                    <label>Location:</label>
                                    <MultiSelectDropdown
                                        options={this.state.locationList}
                                        value={this.state.jobForm.locationid}
                                        onChange={(selected) => this.handleSelectChange(selected, 'locationid')}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        className={`${this.state.validState?.error?.locationid ? "error" : ""}`}
                                    />
                                    <ValidationText error={this.state.validState.error.locationid} />
                                </div>
                                <div className='input-grp !mb-0'>
                                    <label>Job type:</label>
                                    <MultiSelectDropdown
                                        options={this.state.jobTypeOptions}
                                        value={this.state.jobForm.jobtype}
                                        onChange={(selected) => this.handleSelectChange(selected, 'jobtype')}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        className={`${this.state.validState?.error?.jobtype ? "error" : ""}`}
                                    />
                                    <ValidationText error={this.state.validState.error.jobtype} />
                                </div>
                            </div>
                        </div>
                        <div className='job-description p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                            <h2 className='text-[16px] font-semibold mt-0'>Job description</h2>
                            <div className='mt-2 border border-gray-300 rounded-0 overflow-hidden'>
                                <JoditEditor
                                    ref={this.editorRef}
                                    value={this.state.jobForm.jobcontent}
                                    onBlur={(newContent) => this.handleJobDescriptionChange(newContent)}
                                    onChange={() => { }}
                                    tabIndex={1}
                                    className={`${this.state.validState?.error?.jobcontent ? "error" : ""}`}
                                    config={this.editorConfig}
                                />
                                <ValidationText error={this.state.validState.error.jobcontent} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='sticky bottom-0 bg-white border-t border-slate-200 z-30 px-[30px] py-[30px] flex items-center justify-between' style={{ borderTop: "1px solid rgb(0,0,0,0.1)", boxShadow: "0 -7px 12px -6px rgb(14, 63, 126, 0.04)" }}>
                    <div className='btn-left'>
                        <button
                            onClick={() => { this.setState({ route: "/jobs" }) }}
                            className='font-medium text-[16px] text-[#223645] leading-[24px] px-[24px] py-[12px] rounded-[14px] bg-[#EBEBEB] hover:bg-[#dddddd] border-0 flex items-center gap-[5px]'>
                            <FontAwesomeIcon icon={faArrowLeftLong} className='w-5 h-5' />Back
                        </button>
                    </div>
                    <div className='btn-right flex items-center gap-5'>
                        {this.state.jobId > 0 ?
                            <>
                                <button
                                    onClick={() => this.handleDelete()}
                                    className='font-medium text-[16px] text-[#EA3636] hover:text-[#ffffff] leading-[24px] px-[24px] py-[12px] rounded-[14px] border-0 bg-[#ffe8e8] hover:bg-[#EA3636] flex items-center gap-[5px]'>
                                    <FontAwesomeIcon icon={faTrashCan} className='w-5 h-5' />Delete
                                </button>
                                <button
                                    onClick={() => this.updateJob()}
                                    className='font-medium text-[16px] text-[#FFFFFF] leading-[24px] px-[24px] py-[12px] rounded-[14px] bg-[#0077B6] hover:bg-[#3b82f6] border-0'>
                                    {this.state.isLoading ? <FontAwesomeIcon icon={faCircleNotch} spin /> : "Update"}
                                </button>
                            </>
                            :
                            <button
                                onClick={() => this.createJob()}
                                className='font-medium text-[16px] text-[#FFFFFF] leading-[24px] px-[24px] py-[12px] rounded-[14px] bg-[#0077B6] hover:bg-[#3b82f6] border-0'>
                                {this.state.isLoading ? <FontAwesomeIcon icon={faCircleNotch} spin /> : "Save"}
                            </button>
                        }
                    </div>
                </div>
            </div>
        )
    }
}